/**
 * ai.service.ts — Layer 3: AI-assisted writing features
 */

import { postRequest } from './http.service';
import { URL_EMAIL_MAGIC_EDIT, URL_EMAIL_GRAPHRAG, URL_PYTHON_COMMS_AGENT } from './url.service';

/** Rewrite selected text per a free-form instruction prompt */
export const magicEditText = (selectedText: string, prompt: string) =>
  postRequest(URL_EMAIL_MAGIC_EDIT, { selected_text: selectedText, prompt });

/** Ask a GraphRAG question scoped to a client's email history */
export const queryEmailGraphRag = (clientId: string, query: string) =>
  postRequest(URL_EMAIL_GRAPHRAG(clientId), { query });

/** Generate an SMS/email draft via the comms-agent AI (Python proxy) */
export const generateCommsMessage = (payload: Record<string, unknown>) =>
  postRequest(URL_PYTHON_COMMS_AGENT, payload);
